import Heading from '@zenbusiness/zui/Heading';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import WistiaVideo from '#client/components/WistiaVideo';

import {
  FormModalStyled,
  OuterContainer,
  SubtitleStyled,
  TitleStyled,
  TranscriptContainer,
  WistaVideoContainer
} from './BankingVideoModal.styles';

export default function BankingVideoModal({ handleClose }) {
  return (
    <FormModalStyled handleClose={handleClose}>
      <OuterContainer>
        <TitleStyled
          size="xl"
          weight="medium"
        >
          ZenBusiness Banking
        </TitleStyled>
        <WistaVideoContainer>
          <WistiaVideo
            playerColor="000000"
            videoId="9j40doq2gz"
            wrapper="demo-video"
          />
        </WistaVideoContainer>
      </OuterContainer>
      <TranscriptContainer>
        <Heading size="4xl">Mark Cuban Approved - Get started with Banking</Heading>
        <SubtitleStyled
          size="2xl"
          weight="bold"
        >
          Video transcript
        </SubtitleStyled>
        <Text size="md">
          This is your life, you want to get it right.
          <br />
          <br />
          So now you&apos;re ready. It&apos;s time! It&apos;s time to start. You did everything you
          needed to do.
          <br />
          <br />
          The best form of incorporation is what they call an LLC. It limits your liability when you
          do business.
          <br />
          <br />
          When you&apos;re starting, don&apos;t you want to know where every single penny goes? This
          is critical information!
          <br />
          <br />
          A business bank account is a little bit different than a personal bank account. You may
          want a credit card or a debit card associated with it. Then not only do you want a bank
          account to track your money, you want to be able to have an accounting system that keeps
          track of: are you making money or losing money?
          <br />
          <br />
          Every company needs sales, right? How do you get sales? You get sales with marketing. All
          those things are just the little things you need to do, and ZenBusiness can help.
        </Text>
      </TranscriptContainer>
    </FormModalStyled>
  );
}

BankingVideoModal.propTypes = {
  handleClose: PropTypes.func.isRequired
};
